import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-vehicle-verification',
  templateUrl: './vehicle-verification.component.html',
  styleUrls: ['./vehicle-verification.component.css']
})
export class VehicleVerificationComponent implements OnInit {

  @Input() vehicle: any;
  @Output() closeModal = new EventEmitter<any>
  vehicleVarificationForm!: FormGroup;


  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {

    this.vehicleVarificationForm = this.fb.group({
      description: [''],
      vin: [''],
      licensePlateNumber: [''],
      year: [''],
      make: [''],
      model: [''],
      color: [''],
      spaceTypes: [[]],
      garageAddress: this.fb.group({
        name: [''],
        coords: [''],
        city: [''],
        state: ['']
      }),
      serviceAreas: [[]],
      images: this.fb.group({
        registration: [],
        inspectionReport: [],
        vehicle: [],
        back: [],
        left: [],
        right: [],
      }),
      dates: this.fb.group({
        // preRegistration: [],
        registration: [],
        approvalDate: [moment().toISOString],
        inspectionReport: []
      }),
      company: ['']
    });

    if (this.vehicle) {
      this.vehicleVarificationForm.patchValue({
        ...this.vehicle,
        dates:{
          registration: moment(this.vehicle?.dates?.registration).format('MM/DD/YYYY'),
          inspectionReport: moment(this.vehicle?.dates?.inspectionReport).format('MM/DD/YYYY'),
        }
      })
    }
  }

  onCloseModal() {
    this.closeModal.emit();
  }

  onsave(){
    console.log('formvalue', this.vehicleVarificationForm.value);
  }

  get datesForm() {
    return this.vehicleVarificationForm.controls.dates as FormGroup
  }
}
